<template>
  <div class="app-wrapper-footer">
    <div class="app-footer">
      <div class="app-footer__inner"><slot></slot></div>
    </div>
  </div>
</template>
<script>
export default {
  name: 't-footer'
}
</script>
